import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import CustomerListResults from 'components/Customers/CustomerListResults';

const mapStateToProps = (state) => ({
  activeUserType: state.activeUserType,
  customers: state.customers,
  idGen: state.idGen,
  user: state.user
});

const CustomerList = (props) => (
  <>
    <Helmet>
      <title>Customers | Duot Khayat</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <CustomerListResults
          activeUserType={props.activeUserType}
          customers={props.customers}
          idGen={props.idGen}
          user={props.user}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (CustomerList);
